import React from 'react'
import EventsContext from 'services/events/EventsContext'

export default function EventsManager ({ children }) {
  const callbacksRef = React.useRef({})

  const trigger = function (name) {
    const callbacks = callbacksRef.current[name]

    return Promise.resolve()
      .then(() => {
        if (typeof callbacks !== 'undefined' && callbacks.length > 0) {
          return new Promise((resolve, reject) => {
            let promise = Promise.resolve()

            callbacks.forEach((callback) => {
              promise = promise.then(() => {
                return callback.apply(this, Array.prototype.slice.call(arguments, 0))
              })
            })

            promise
              .then((p) => {
                resolve(p)
              })
              .catch((err) => {
                reject(err)
              })
          })
        }
      })
  }

  const removeEventListener = (name, callback) => {
    const callbacks = callbacksRef.current[name]
    if (typeof callback !== 'undefined' && callbacks.length > 0) {
      callbacks.forEach((_callback, index) => {
        if (callbacks[index] === callback) {
          delete callbacks[index]
        }
      })
    }
  }

  const addEventListener = (name, callback) => {
    if (typeof callbacksRef.current[name] === 'undefined') {
      callbacksRef.current[name] = []
    }

    callbacksRef.current[name].push(callback)

    const disposer = () => {
      removeEventListener(name, callback)
    }

    return disposer
  }

  const manager = {
    onEvent: addEventListener,
    trigger: trigger
  }

  return (
    <EventsContext.Provider value={manager}>
      {children}
    </EventsContext.Provider>
  )
}
